import {LineChartOutlined, CalculatorOutlined} from '@ant-design/icons';
import { Radio } from 'antd';

export const AnalyticChartChange = ({isHasAnalytic, onChartKindChange}) => {

    const options = () => {
        let values = new Array();

        if (isHasAnalytic) {
            values.push(            {
                label: <CalculatorOutlined />,
                value: 'analytic'
            });
        }         

        values.push({             
            label: <LineChartOutlined />,
            value: 'chart'
        });

       return values;

    }

    return (
    <Radio.Group 
        onChange={onChartKindChange}                                
        block 
        options={options()}    

        defaultValue="chart" optionType="button" 
    />
)}